/*
  Packages page behaviour — loaded ONLY by templates/page.packages.liquid:
    <script src="{{ 'packages.js' | asset_url }}" defer></script>
  Hand-written source (not a Gulp output): plain ES5 so it runs without a
  build step. Edit it here; theme watch uploads it like any theme file.

  Reads its settings from the JSON block
  #packages-config (default unit, professional code, discount rate and
  minimum, cart caps) and drives:
    - package selection (table column buttons, phone tabs, #hash links)
    - the page-wide order format (Singles / Cases of 12), including the
      table's column totals
    - the preferred flavor, per-line flavor choice and include/exclude
    - the card total: regular price; for a signed-in professional with a
      30off code ordering CASES (never singles), the discounted total with the
      amount saved once the package reaches the $300 minimum (same rule as
      cart-discount_estimate — checkout prices the code)
    - one AJAX add of every ticked line, after re-checking the cart caps
      against /cart.js (2 singles per product, 10 cases per variant — the
      same caps cart-add_toast and the cart rows enforce)
*/
(function () {
  var page = document.querySelector('[data-packages-page]');
  var configElement = document.getElementById('packages-config');
  if (!page || !configElement) return;
  var config = JSON.parse(configElement.textContent);

  var cards = Array.prototype.slice.call(page.querySelectorAll('[data-package-card]'));
  var panels = Array.prototype.slice.call(page.querySelectorAll('[data-package-panel]'));

  function cardOf(element) { return element.closest('[data-package-card]'); }
  function panelsOf(card) { return Array.prototype.slice.call(card.querySelectorAll('[data-package-panel]')); }
  /* The table page: one card holding every package's panel, switched by
     package selection. The cards page: several cards, each its own single
     panel — there is nothing to "select" page-wide, so the URL hash (and
     everything else keyed to a single active package) stays untouched. */
  var hasPackageSelection = cards.length === 1 && panelsOf(cards[0]).length > 1;
  /* The panel a card is showing: its only panel on the cards page, the
     chosen one on the table page. */
  function activePanelOf(card) {
    var cardPanels = panelsOf(card);
    if (cardPanels.length === 1) return cardPanels[0];
    return cardPanels.filter(function (panel) { return !panel.hidden; })[0] || cardPanels[0];
  }

  /* ?professional in the URL (QR codes, links handed to clinics) starts on
     Cases, as a signed-in professional account does. */
  var professionalLink = /[?&]professional(=|&|$)/.test(location.search);
  /* ?unit=cases / ?unit=singles says the view outright, so a shared or printed
     link opens the way it was sent; the switch keeps the param current. */
  var requestedUnit = (location.search.match(/[?&]unit=(cases|singles)/) || [])[1];
  var state = {
    packageId: null,
    unit: config.lockedUnit || requestedUnit || (config.defaultUnit === 'cases' || professionalLink ? 'cases' : 'singles')
  };

  function rememberUnitInUrl(unit) {
    if (!history.replaceState || !window.URLSearchParams) return;
    var params = new URLSearchParams(location.search);
    params.set('unit', unit);
    history.replaceState(null, '', location.pathname + '?' + params.toString() + location.hash);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function lineChoiceSelect(line) {
    return line.querySelector('[data-package-line-choice]');
  }

  function selectedChoice(line) {
    var select = lineChoiceSelect(line);
    return select.options[select.selectedIndex];
  }

  function unitDetails(choice) {
    var prefix = state.unit === 'cases' ? 'case' : 'single';
    var otherPrefix = prefix === 'case' ? 'single' : 'case';
    return {
      variantId: parseInt(choice.dataset[prefix + 'VariantId'], 10),
      cents: parseInt(choice.dataset[prefix + 'Cents'], 10),
      buyable: choice.dataset[prefix + 'Buyable'] === 'true',
      otherUnitBuyable: choice.dataset[otherPrefix + 'Buyable'] === 'true',
      productId: parseInt(choice.dataset.productId, 10),
      name: choice.dataset.name + (choice.dataset.flavor ? ' — ' + choice.dataset.flavor : '')
    };
  }

  /* Index of the option matching flavor and size. Without exactMatch,
     falls back to the first option with that flavor (or size) so a switch
     click always lands somewhere; returns null when nothing matches. */
  function findChoiceIndex(line, flavor, size, exactMatch) {
    var options = lineChoiceSelect(line).options, fallback = null;
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      var flavorMatches = flavor === null || option.dataset.flavor === flavor;
      var sizeMatches = size === null || option.dataset.detail === size;
      if (flavorMatches && sizeMatches) return { index: index };
      if (!exactMatch && fallback === null && (flavor !== null ? flavorMatches : sizeMatches)) fallback = { index: index };
    }
    return exactMatch ? null : fallback;
  }

  function chooseOption(line, flavor, size) {
    var match = findChoiceIndex(line, flavor, size, false);
    if (match) lineChoiceSelect(line).selectedIndex = match.index;
  }

  function renderHoverCard(hoverCard, choice) {
    if (!hoverCard) return;
    var image = hoverCard.querySelector('[data-hover-image]');
    var largeImage = choice.dataset.largeImage;
    image.hidden = !largeImage || largeImage === '-';
    if (!image.hidden) { image.src = largeImage; image.alt = choice.dataset.name; }
    hoverCard.querySelector('[data-hover-name]').textContent = choice.dataset.name;
    hoverCard.querySelector('[data-hover-subtitle]').textContent =
      [choice.dataset.flavor, choice.dataset.detail].filter(Boolean).join(' · ');
    var blurb = hoverCard.querySelector('[data-hover-blurb]');
    blurb.hidden = !choice.dataset.blurb;
    blurb.textContent = choice.dataset.blurb ? choice.dataset.blurb + '.' : '';
    hoverCard.querySelector('[data-hover-link]').href = choice.dataset.url;
  }

  /* A switch whose options are all but one hidden stops being a choice, so it
     shrinks to the word it shows instead of stretching across the line. */
  function markSingleOptionSwitch(chips) {
    if (!chips.length) return;
    var visible = Array.prototype.filter.call(chips, function (chip) { return !chip.hidden; }).length;
    chips[0].parentElement.classList.toggle('packages-chips--single', visible < 2);
  }

  /* The Flavor/Size pills only, so a click can light its pill at once while
     the rest of the line crossfades (see fadeSwap). */

  function renderLineSwitches(line) {
    var choice = selectedChoice(line);
    var flavorChips = line.querySelectorAll('[data-package-line-flavor-value]');
    var sizeChips = line.querySelectorAll('[data-package-line-size-value]');
    var hasFlavorChoice = flavorChips.length > 0;
    Array.prototype.forEach.call(flavorChips, function (chip) {
      chip.setAttribute('aria-pressed', chip.dataset.packageLineFlavorValue === choice.dataset.flavor ? 'true' : 'false');
    });
    Array.prototype.forEach.call(sizeChips, function (chip) {
      var size = chip.dataset.packageLineSizeValue;
      chip.setAttribute('aria-pressed', size === choice.dataset.detail ? 'true' : 'false');
      /* A size the chosen flavor does not come in is simply not offered. */
      chip.hidden = hasFlavorChoice && !findChoiceIndex(line, choice.dataset.flavor, size, true);
    });
    markSingleOptionSwitch(flavorChips);
    markSingleOptionSwitch(sizeChips);
  }

  /* "Flavor · size" under a line name, with the flavor word in its color —
     the same markup as snippets/packages-flavor_name.liquid, whose class
     suffix is Shopify's handleize ("Lemon Mint" -> lemon-mint). */
  function renderLineDetail(element, flavor, size) {
    element.textContent = '';
    if (flavor) {
      var flavorWord = document.createElement('span');
      flavorWord.className = 'packages-flavor packages-flavor--' +
        flavor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      flavorWord.textContent = flavor;
      element.appendChild(flavorWord);
    }
    if (size) element.appendChild(document.createTextNode((flavor ? ' · ' : '') + size));
  }

  /* How many of a line the shopper wants (cases, or singles). The cart caps apply: 10 cases of a variant,
     2 singles of a product. */
  function maximumQuantity() {
    return state.unit === 'cases' ? config.maximumCasesPerVariant : config.maximumSinglesPerProduct;
  }

  function lineQuantity(line) {
    var quantity = parseInt(line.dataset.quantity || '1', 10);
    if (!(quantity >= 1)) quantity = 1;
    return Math.min(quantity, maximumQuantity());
  }

  function renderLine(line) {
    var choice = selectedChoice(line);
    var details = unitDetails(choice);
    var quantity = lineQuantity(line);
    line.dataset.quantity = String(quantity);
    var hasFlavorChoice = line.querySelector('[data-package-line-flavor-value]') !== null;
    var hasSizeChoice = line.querySelector('[data-package-line-size-value]') !== null;
    renderLineSwitches(line);
    var checkbox = line.querySelector('[data-package-line-checkbox]');
    var status = line.querySelector('[data-package-line-status]');

    line.querySelector('[data-package-line-name]').textContent = choice.dataset.name;
    renderLineDetail(line.querySelector('[data-package-line-detail]'),
      hasFlavorChoice ? '' : choice.dataset.flavor, hasSizeChoice ? '' : choice.dataset.detail);

    checkbox.disabled = !details.buyable;
    checkbox.checked = details.buyable && line.dataset.excludedByShopper !== 'true';
    line.classList.toggle('is-unavailable', !details.buyable);
    line.classList.toggle('is-excluded', details.buyable && !checkbox.checked);

    status.hidden = details.buyable;
    status.textContent = details.buyable ? '' : (details.otherUnitBuyable
      ? (state.unit === 'cases' ? 'Singles only for now' : 'By the case only for now')
      : 'Out of stock');

    renderHoverCard(line.querySelector('[data-package-hover-card]'), choice);

    var unitLabel = state.unit === 'cases' ? 'per case of 12' : 'each';
    line.querySelector('[data-package-line-price]').textContent = details.cents > 0 ? formatMoney(details.cents * quantity) : '';
    line.querySelector('[data-package-line-unit]').textContent = quantity > 1
      ? quantity + ' × ' + formatMoney(details.cents) + ' ' + unitLabel : unitLabel;
    var quantityValue = line.querySelector('[data-package-line-quantity-value]');
    if (quantityValue) quantityValue.textContent = quantity;
    var lessButton = line.querySelector('[data-package-line-quantity-step="-1"]');
    var moreButton = line.querySelector('[data-package-line-quantity-step="1"]');
    if (lessButton) lessButton.disabled = quantity <= 1;
    if (moreButton) moreButton.disabled = quantity >= maximumQuantity();
    renderCollagePhoto(line, choice, checkbox.checked);
  }

  /* The package's photo strip follows its lines: each photo shows the
     chosen flavor and steps out while its line is unticked. */
  function renderCollagePhoto(line, choice, included) {
    var panel = line.closest('[data-package-panel]');
    var card = cardOf(line);
    var selector = '.packages-card-collage img[data-collage-line="' + line.dataset.packageLine + '"]';
    var photo = (panel && panel.querySelector(selector)) || (card && card.querySelector(selector));
    if (!photo) return;
    photo.hidden = !included;
    if (choice.dataset.image && choice.dataset.image !== '-') photo.src = choice.dataset.image;
  }

  function packageLines(panel) {
    return Array.prototype.slice.call(panel.querySelectorAll('[data-package-line]'));
  }

  /* Restarts a one-shot CSS entrance (packages-styles) on each element. */
  function replayEntrance(elements, className) {
    Array.prototype.forEach.call(elements, function (element) {
      if (!element) return;
      element.classList.remove(className);
      void element.offsetWidth;
      element.classList.add(className);
    });
  }

  /* Crossfade for values that change in place (prices, names, photos):
     fade the old value out, run update() while it is invisible, fade the
     new one in. A second change during the fade finishes the first at once. */
  var FADE_OUT_MILLISECONDS = 140;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pendingFade = null;

  function finishPendingFade() {
    if (!pendingFade) return;
    var fade = pendingFade;
    pendingFade = null;
    clearTimeout(fade.timer);
    fade.update();
    fade.elements.forEach(function (element) { element.classList.remove('packages-value-hidden'); });
  }

  function fadeSwap(elements, update) {
    finishPendingFade();
    var fadingElements = Array.prototype.filter.call(elements, Boolean);
    if (prefersReducedMotion || fadingElements.length === 0) { update(); return; }
    fadingElements.forEach(function (element) {
      element.classList.add('packages-value-fade', 'packages-value-hidden');
    });
    pendingFade = { elements: fadingElements, update: update, timer: setTimeout(finishPendingFade, FADE_OUT_MILLISECONDS) };
  }

  function includedLines(panel) {
    return packageLines(panel).filter(function (line) {
      var checkbox = line.querySelector('[data-package-line-checkbox]');
      return checkbox.checked && !checkbox.disabled;
    });
  }

  function renderCard(card) {
    var panel = activePanelOf(card);
    if (!panel) return;
    var selectedNameElement = card.querySelector('[data-package-selected-name]');
    var countElement = card.querySelector('[data-package-count]');
    var totalLabelElement = card.querySelector('[data-package-total-label]');
    var subtotalRow = card.querySelector('[data-package-subtotal-row]');
    var subtotalElement = card.querySelector('[data-package-subtotal]');
    var discountRow = card.querySelector('[data-package-discount-row]');
    var discountLabelElement = card.querySelector('[data-package-discount-label]');
    var discountElement = card.querySelector('[data-package-discount]');
    var codeElement = card.querySelector('[data-package-code]');
    var totalElement = card.querySelector('[data-package-total]');
    var estimateElement = card.querySelector('[data-package-estimate]');
    var addButton = card.querySelector('[data-package-add]');
    var lines = includedLines(panel);
    var count = lines.length;
    var totalCents = lines.reduce(function (sum, line) { return sum + unitDetails(selectedChoice(line)).cents * lineQuantity(line); }, 0);
    var cases = state.unit === 'cases';

    /* The package names already end in "Bundle". */
    selectedNameElement.textContent = panel.dataset.packageName;
    if (countElement) countElement.textContent = count + ' of ' + packageLines(panel).length + ' selected';
    totalLabelElement.textContent = cases ? 'Combined regular case price' : 'Combined regular price';
    subtotalElement.textContent = formatMoney(totalCents);
    totalElement.textContent = formatMoney(totalCents);
    subtotalRow.hidden = true;
    discountRow.hidden = true;
    codeElement.hidden = true;
    estimateElement.hidden = true;

    /* The professional discount is shown on CASES only — never on singles.
       Same rows as the cart summary: subtotal, the amount taken off with the
       code beneath it, then the total. */
    if (config.professionalCode && count > 0 && cases) {
      estimateElement.hidden = false;
      if (totalCents >= config.discountMinimumCents) {
        var savedCents = Math.round(totalCents * config.discountRate);
        subtotalRow.hidden = false;
        discountRow.hidden = false;
        discountLabelElement.textContent = 'Discount · ' + Math.round(config.discountRate * 100) + '% off';
        discountElement.textContent = '− ' + formatMoney(savedCents);
        codeElement.hidden = false;
        codeElement.textContent = config.professionalCode;
        totalElement.textContent = formatMoney(totalCents - savedCents);
        estimateElement.textContent = 'Discount applied automatically.';
      } else {
        estimateElement.textContent = 'Your ' + config.professionalCode + ' code applies at checkout on orders of ' +
          formatMoney(config.discountMinimumCents) + ' or more.';
      }
    }

    addButton.disabled = count === 0;
    addButton.textContent = count === 0
      ? 'Select an item'
      : 'Add ' + count + (cases ? (count === 1 ? ' case' : ' cases') : (count === 1 ? ' item' : ' items')) + ' to cart';
  }

  function renderColumnTotals() {
    var cases = state.unit === 'cases';
    var discountRow = page.querySelector('[data-package-columns-discount-row]');
    var finalRow = page.querySelector('[data-package-columns-final-row]');
    /* Same discount rule as the card: professional, cases only. Shown as its
       own Discount / With discount row pair so every column's discounted
       price sits beside the others, not just the selected package's. */
    var showDiscountRows = Boolean(config.professionalCode) && cases;
    if (discountRow) discountRow.hidden = !showDiscountRows;
    if (finalRow) finalRow.hidden = !showDiscountRows;

    page.querySelectorAll('[data-singles-total]').forEach(function (cell) {
      cell.querySelector('[data-package-column-total]').textContent =
        cases ? cell.dataset.casesTotal : cell.dataset.singlesTotal;
      if (!showDiscountRows) return;

      var packageId = cell.dataset.packageColumn;
      var discountCell = page.querySelector('[data-package-column-discount][data-package-column="' + packageId + '"]');
      var finalCell = page.querySelector('[data-package-column-final][data-package-column="' + packageId + '"]');
      if (!discountCell || !finalCell) return;
      var casesTotalCents = Number(cell.dataset.casesTotalCents);
      var qualifies = casesTotalCents >= config.discountMinimumCents;
      discountCell.hidden = !qualifies;
      finalCell.hidden = !qualifies;
      if (!qualifies) return;
      var savedCents = Math.round(casesTotalCents * config.discountRate);
      discountCell.textContent = '− ' + formatMoney(savedCents);
      discountCell.dataset.tip = Math.round(config.discountRate * 100) + '% off with ' + config.professionalCode;
      finalCell.textContent = formatMoney(casesTotalCents - savedCents);
    });
    var note = page.querySelector('[data-package-total-note]');
    if (note) note.textContent = cases ? 'Combined regular case price' : 'Combined regular price';
  }

  function selectPackage(packageId) {
    if (!panels.some(function (panel) { return panel.dataset.packagePanel === packageId; })) return;
    finishPendingFade();
    var switchedPackage = state.packageId !== null && state.packageId !== packageId;
    state.packageId = packageId;
    cards.forEach(function (card) {
      if (panelsOf(card).length > 1) {
        panelsOf(card).forEach(function (panel) { panel.hidden = panel.dataset.packagePanel !== packageId; });
      }
    });
    page.querySelectorAll('[data-package-column]').forEach(function (cell) {
      cell.classList.toggle('is-selected', cell.dataset.packageColumn === packageId);
    });
    page.querySelectorAll('.packages-compare-choose').forEach(function (button) {
      var selected = button.dataset.packageSelect === packageId;
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.querySelector('[data-package-action]').textContent = selected ? 'Selected' : 'Choose';
    });
    page.querySelectorAll('.packages-tab').forEach(function (tab) {
      tab.setAttribute('aria-selected', tab.dataset.packageSelect === packageId ? 'true' : 'false');
    });
    cards.forEach(function (card) {
      packageLines(activePanelOf(card)).forEach(renderLine);
      renderCard(card);
      showMessage(card, '');
    });
    if (switchedPackage) {
      cards.forEach(function (card) {
        replayEntrance([activePanelOf(card), card.querySelector('[data-package-total]')], 'packages-panel-entering');
      });
    }
    if (hasPackageSelection && history.replaceState) history.replaceState(null, '', '#' + packageId);
  }

  /* withoutFade: the first render on page load, which has nothing to fade from. */
  function selectUnit(unit, withoutFade) {
    state.unit = unit;
    rememberUnitInUrl(unit);
    page.querySelectorAll('[data-package-unit]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.packageUnit === unit ? 'true' : 'false');
    });
    var renderPrices = function () {
      panels.forEach(function (panel) { packageLines(panel).forEach(renderLine); });
      renderColumnTotals();
      cards.forEach(function (card) {
        renderCard(card);
        showMessage(card, '');
      });
    };
    if (withoutFade) { renderPrices(); return; }
    fadeSwap(page.querySelectorAll('[data-package-column-total], [data-package-line-price], [data-package-total], [data-package-estimate]'), renderPrices);
  }

  function applyPreferredFlavor(flavor) {
    page.querySelectorAll('[data-package-preferred-flavor]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.packagePreferredFlavor === flavor ? 'true' : 'false');
    });
    panels.forEach(function (panel) {
      packageLines(panel).forEach(function (line) {
        if (!line.querySelector('[data-package-line-flavor-value]')) return;
        var current = selectedChoice(line);
        if (findChoiceIndex(line, flavor, null, true)) chooseOption(line, flavor, current.dataset.detail);
        renderLine(line);
      });
    });
    cards.forEach(function (card) {
      renderCard(card);
      showMessage(card, '');
    });
  }

  function showMessage(card, html, tone) {
    var messageElement = card.querySelector('[data-package-message]');
    messageElement.innerHTML = html;
    messageElement.hidden = !html;
    messageElement.dataset.tone = tone || '';
  }

  /* The site-wide cart script re-renders every cart icon and its hover preview; the badge-only update is the fallback. */
  function refreshCartBadge(cart) {
    if (window.slRefreshCartLinks) { window.slRefreshCartLinks(); return; }
    document.querySelectorAll('#label-cart-count-badge').forEach(function (badge) {
      badge.textContent = cart.item_count;
    });
  }

  function capBlockedNames(cart, additions) {
    return additions.filter(function (addition) {
      var singlesOfProduct = 0, quantityOfVariant = 0;
      cart.items.forEach(function (item) {
        var isSingle = (item.variant_options || []).indexOf('single unit') !== -1;
        if (isSingle && item.product_id === addition.productId) singlesOfProduct += item.quantity;
        if (item.variant_id === addition.variantId) quantityOfVariant += item.quantity;
      });
      return addition.unit === 'singles'
        ? singlesOfProduct + addition.quantity > config.maximumSinglesPerProduct
        : quantityOfVariant + addition.quantity > config.maximumCasesPerVariant;
    }).map(function (addition) { return addition.name; });
  }

  /* The "Adding" overlay covers the modal's card only (other layouts show none). The dialog scrolls, so the overlay is
     fixed to the dialog's on-screen box and sits on the frame around it instead of inside the scrolling content. */
  function showAddingOverlay(card) {
    var dialog = card.closest('.packages-bundle-modal-dialog');
    var frame = card.closest('.packages-bundle-modal');
    if (!dialog || !frame) return null;
    var box = dialog.getBoundingClientRect();
    var overlay = document.createElement('div');
    overlay.className = 'sl-loading-overlay';
    overlay.setAttribute('role', 'status');
    overlay.style.cssText = 'position:fixed;inset:auto;top:' + box.top + 'px;left:' + box.left + 'px;width:' + box.width +
      'px;height:' + box.height + 'px;border-radius:18px;';
    overlay.innerHTML = '<span class="sl-loading-spinner"></span><span>Adding to your cart&hellip;</span>';
    frame.appendChild(overlay);
    return overlay;
  }

  function showAddedOverlay(overlay) {
    if (!overlay) return;
    overlay.innerHTML = '<span class="sl-loading-check">&#10003;</span><span>Added to your cart</span>';
    setTimeout(function () { removeOverlay(overlay); }, 900);
  }

  function removeOverlay(overlay) {
    if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }

  function addPackageToCart(card) {
    finishPendingFade();
    var panel = activePanelOf(card);
    var addButton = card.querySelector('[data-package-add]');
    var additions = includedLines(panel).map(function (line) {
      var details = unitDetails(selectedChoice(line));
      return { variantId: details.variantId, productId: details.productId, name: details.name, unit: state.unit, quantity: lineQuantity(line) };
    });
    if (!additions.length) return;
    addButton.classList.add('is-busy');
    var addingOverlay = showAddingOverlay(card);

    fetch('/cart.js').then(function (response) { return response.json(); }).then(function (cart) {
      var blocked = capBlockedNames(cart, additions);
      if (blocked.length) {
        throw { friendly: 'Your cart already holds the maximum for: ' + blocked.join(', ') +
          '. Untick ' + (blocked.length === 1 ? 'it' : 'them') + ' or <a href="/cart">adjust your cart</a>.' };
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        /* _bundle is hidden from the shopper (leading underscore) but lands on the order line, so bundle revenue is traceable. */
        body: JSON.stringify({ items: additions.map(function (addition) {
          return { id: addition.variantId, quantity: addition.quantity, properties: { _bundle: panel.dataset.packageName } };
        }) })
      });
    }).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok) throw { friendly: body.description || 'Those items could not be added.' };
        return fetch('/cart.js');
      });
    }).then(function (response) { return response.json(); }).then(function (cart) {
      refreshCartBadge(cart);
      var addedCount = additions.reduce(function (sum, addition) { return sum + addition.quantity; }, 0);
      var addedWord = state.unit === 'cases' ? (addedCount === 1 ? 'case' : 'cases') : (addedCount === 1 ? 'item' : 'items');
      showMessage(card, 'Added ' + addedCount + ' ' + addedWord +
        ' from the ' + panel.dataset.packageName + ' bundle. <a href="/cart">View cart &rarr;</a>', 'success');
      /* Confirm in the site-wide toast, and let the modal layout close itself. */
      if (window.slShowCartToast) {
        window.slShowCartToast(addedCount + ' ' + addedWord + ' from the ' + panel.dataset.packageName + ' bundle', 'Added to cart', true);
      }
      showAddedOverlay(addingOverlay);
      document.dispatchEvent(new CustomEvent('packages:added', { detail: { packageName: panel.dataset.packageName, count: addedCount } }));
      if (window.rybbit && typeof window.rybbit.event === 'function') {
        try {
          window.rybbit.event('Bundle added', { bundle: panel.dataset.packageName, unit: state.unit, count: addedCount, lines: additions.length });
        } catch (analyticsFailure) {}
      }
    }).catch(function (error) {
      removeOverlay(addingOverlay);
      showMessage(card, error && error.friendly ? error.friendly : 'Something went wrong. Please try again or <a href="/cart">open your cart</a>.', 'error');
    }).then(function () {
      addButton.classList.remove('is-busy');
    });
  }

  page.addEventListener('click', function (event) {
    var packageTrigger = event.target.closest('[data-package-select]');
    if (packageTrigger) { selectPackage(packageTrigger.dataset.packageSelect); return; }
    var columnCell = event.target.closest('.packages-compare [data-package-column]');
    if (columnCell) { selectPackage(columnCell.dataset.packageColumn); return; }
    var quantityTrigger = event.target.closest('[data-package-line-quantity-step]');
    if (quantityTrigger) {
      var quantityLine = quantityTrigger.closest('[data-package-line]');
      var quantityCard = cardOf(quantityLine);
      var wanted = lineQuantity(quantityLine) + parseInt(quantityTrigger.dataset.packageLineQuantityStep, 10);
      quantityLine.dataset.quantity = String(Math.max(1, Math.min(wanted, maximumQuantity())));
      renderLine(quantityLine);
      if (quantityCard) { renderCard(quantityCard); showMessage(quantityCard, ''); }
      return;
    }
    var unitTrigger = event.target.closest('[data-package-unit]');
    if (unitTrigger) { selectUnit(unitTrigger.dataset.packageUnit); return; }
    var lineSwitch = event.target.closest('[data-package-line-flavor-value], [data-package-line-size-value]');
    if (lineSwitch) {
      var switchLine = lineSwitch.closest('[data-package-line]');
      var switchCard = cardOf(switchLine);
      var current = selectedChoice(switchLine);
      if (lineSwitch.dataset.packageLineFlavorValue !== undefined) {
        chooseOption(switchLine, lineSwitch.dataset.packageLineFlavorValue, current.dataset.detail);
      } else {
        chooseOption(switchLine, current.dataset.flavor || null, lineSwitch.dataset.packageLineSizeValue);
      }
      renderLineSwitches(switchLine);
      var changingElements = Array.prototype.slice.call(
        switchLine.querySelectorAll('[data-package-line-name], [data-package-line-detail], [data-package-line-price]'));
      changingElements.push(switchCard.querySelector('[data-package-total]'));
      fadeSwap(changingElements, function () {
        renderLine(switchLine);
        renderCard(switchCard);
        showMessage(switchCard, '');
      });
      return;
    }
    var flavorTrigger = event.target.closest('[data-package-preferred-flavor]');
    if (flavorTrigger) applyPreferredFlavor(flavorTrigger.dataset.packagePreferredFlavor);
  });

  // The whole column is the click target, so light the whole column on hover.
  var compareTable = page.querySelector('[data-packages-compare]');
  if (compareTable) {
    compareTable.addEventListener('mouseover', function (event) {
      var cell = event.target.closest('[data-package-column]');
      var hoveredId = cell ? cell.dataset.packageColumn : null;
      compareTable.querySelectorAll('[data-package-column]').forEach(function (columnCell) {
        columnCell.classList.toggle('is-column-hovered', columnCell.dataset.packageColumn === hoveredId);
      });
    });
    compareTable.addEventListener('mouseleave', function () {
      compareTable.querySelectorAll('.is-column-hovered').forEach(function (columnCell) {
        columnCell.classList.remove('is-column-hovered');
      });
    });
    compareTable.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var cell = event.target.closest('td[data-package-column]');
      if (!cell) return;
      event.preventDefault();
      selectPackage(cell.dataset.packageColumn);
    });
  }

  page.addEventListener('change', function (event) {
    var line = event.target.closest('[data-package-line]');
    if (!line) return;
    if (event.target.matches('[data-package-line-checkbox]')) {
      line.dataset.excludedByShopper = event.target.checked ? 'false' : 'true';
    }
    renderLine(line);
    var changeCard = cardOf(line);
    renderCard(changeCard);
    showMessage(changeCard, '');
  });

  cards.forEach(function (card) {
    card.querySelector('[data-package-add]').addEventListener('click', function () { addPackageToCart(card); });
  });

  var requestedPackage = location.hash.replace('#', '');
  selectUnit(state.unit, true);
  selectPackage(panels.some(function (panel) { return panel.dataset.packagePanel === requestedPackage; })
    ? requestedPackage
    : (panels[0] && panels[0].dataset.packagePanel));
})();
